/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Email } from '../models/Email';
import type { PaginatedProviderReferenceResponseList } from '../models/PaginatedProviderReferenceResponseList';
import type { PatchedProviderReferenceResponse } from '../models/PatchedProviderReferenceResponse';
import type { ProviderReferenceResponse } from '../models/ProviderReferenceResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReferenceResponseService {

    /**
     * The public survey a reference fills in; keyed by the response id from their email.
     * @returns ProviderReferenceResponse
     * @throws ApiError
     */
    public static referenceResponseRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this provider reference response.
         */
        id: string,
    }): CancelablePromise<ProviderReferenceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/reference-response/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * The public survey a reference fills in; keyed by the response id from their email.
     * @returns ProviderReferenceResponse
     * @throws ApiError
     */
    public static referenceResponseUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this provider reference response.
         */
        id: string,
        requestBody?: ProviderReferenceResponse,
    }): CancelablePromise<ProviderReferenceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/reference-response/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * The public survey a reference fills in; keyed by the response id from their email.
     * @returns ProviderReferenceResponse
     * @throws ApiError
     */
    public static referenceResponsePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this provider reference response.
         */
        id: string,
        requestBody?: PatchedProviderReferenceResponse,
    }): CancelablePromise<ProviderReferenceResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/reference-response/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Outstanding Provider References Lookup
     * Fetch any outstanding endorsements for provider references sent to given email address
     * @returns PaginatedProviderReferenceResponseList
     * @throws ApiError
     */
    public static providerReferenceResponsesOutstanding({
        requestBody,
        limit,
        offset,
    }: {
        requestBody: Email,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedProviderReferenceResponseList> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/reference-response/outstanding/',
            query: {
                'limit': limit,
                'offset': offset,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
